import { render, staticRenderFns } from "./ClientCreateBranchMobile.vue?vue&type=template&id=37aa1d64&scoped=true&"
import script from "./ClientCreateBranchMobile.vue?vue&type=script&lang=js&"
export * from "./ClientCreateBranchMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa1d64",
  null
  
)

export default component.exports